import clsx from "clsx";
import { ReactNode } from "react";
import styles from "./rlcard.module.scss";

type RLCardNoDataProps = {
  className?: string;
  children: ReactNode;
};

const RLCardNoData = ({ children, className }: RLCardNoDataProps) => (
  <div className={clsx(styles.rlcard_no_data, className)}>{children}</div>
);

export default RLCardNoData;
